var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9772 15.7681L12 11.5L7.02287 15.7681C6.62915 16.1221 6.04322 16.0641 5.71543 15.6401C5.57057 15.4531 5.5 15.2261 5.5 15.0001C5.5 14.7141 5.61422 14.4301 5.83429 14.2321L11.4058 9.232C11.4494 9.193 11.5005 9.173 11.5488 9.144C11.5878 9.12 11.6212 9.091 11.6639 9.073C11.7707 9.028 11.883 9.001 11.9963 9.001L12 9L12.0038 9.001C12.117 9.001 12.2294 9.028 12.3362 9.073C12.3789 9.091 12.4123 9.12 12.4513 9.144C12.4996 9.173 12.5507 9.193 12.5943 9.232L18.1658 14.2321C18.5595 14.5851 18.6134 15.2151 18.2847 15.6401C17.9569 16.0641 17.3709 16.1221 16.9772 15.7681Z",
    fill: "#2E3A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.427e2e51bc5423bef2d748fd7b52416a.svg";
export { ForwardRef as ReactComponent };